module.exports = __webpack_public_path__ + "img/kideducate_test.4c3e92ad.svg";